import {
    parse
} from 'matchit'
const util = {}

/**
 * @description 更新标题
 * @param {String} title 标题
 */
util.title = function(titleText) {
    const processTitle = process.env.VUE_APP_TITLE || 'D2Admin'
    window.document.title = `${processTitle}${titleText ? ` | ${titleText}` : ''}`
}

/**
 * @description 打开新页面
 * @param {String} url 地址
 */
util.open = function(url) {
    var a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('target', '_blank')
    a.setAttribute('id', 'd2admin-link-temp')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(document.getElementById('d2admin-link-temp'))
}
/**
 * @description 获取地址栏参数
 * @param {String} url 地址
 */
util.getUrlKey = function(name) {
    // eslint-disable-next-line no-sparse-arrays
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
}

/**
 * @description 处理接口
 * @param {Array} interfaces 接口
 */
util.formatInterfaces = function(interfaces) {
    let i = {}
    i['GET'] = interfaces.filter(s => s.method.toUpperCase() === 'GET').map(s => parse(s.path))
    i['POST'] = interfaces.filter(s => s.method.toUpperCase() === 'POST').map(s => parse(s.path))
    i['PUT'] = interfaces.filter(s => s.method.toUpperCase() === 'PUT').map(s => parse(s.path))
    i['DELETE'] = interfaces.filter(s => s.method.toUpperCase() === 'DELETE').map(s => parse(s.path))
    return i
}
/**
 *map转化为对象（map所有键都是字符串，可以将其转换为对象）
 */
util.strMapToObj = function(strMap) {
    let obj = Object.create(null)
    for (let [k, v] of strMap) {
        obj[k] = v
    }
    return obj
}
/**
 *map转换为json
 */
util.mapToJson = function(map) {
    return JSON.stringify(util.strMapToObj(map))
}
/*
  对象转化为Map
*/
util.objToStrMap = function(obj) {
    let strMap = new Map()
    for (let k of Object.keys(obj)) {
        strMap.set(k, obj[k])
    }
    return strMap
}
/*
  数组中对象的去重
  targetArr  含有重复对象的数组
  key 根据key来判断, key必须是唯一的
*/
/* util.disRepeatObjInArr = function (targetArr, key) {
  const hash = {}
  const newArr = targetArr.reduceRight((item, next) => {
    hash[next[key]] ? '' : hash[next[key]] = true && item.push(next)
    return item
  }, [])
  return newArr
} */

// 埋入用户id _paq 挂window上了
util.gPaqSet = (paqInfo = '') => {
    let _paq = window._paq || []
    Promise.resolve().then(() => {
        _paq.push(['setUserId', paqInfo])
        _paq.push(['trackPageView'])
    })
}
// 埋入点击事件
util.gPaqClick = ({ btnName = '', msg = '' } = {}) => {
    let _paq = window._paq || []
    Promise.resolve().then(() => {
        _paq.push(['trackEvent', 'click', btnName, msg])
    })
}
// 埋入错误提示
util.gPaqWarn = ({ msg = '' } = {}) => {
    let _paq = window._paq || []
    Promise.resolve().then(() => {
        _paq.push(['trackEvent', 'warning', '错误提示', msg])
    })
}

util.getOptionsLabel = (options = [], val, kField = 'id', labelField = 'label') => {
    if (!options) {
        return '--'
    }
    const item = options.find(item => item[kField] == val)
    if (item) {
        return item[labelField]
    }
    return '--'
}
export default util
